import React from "react";

function Request() {
  return (
    <div>
      <h1>Budget Requests</h1>
      <p>Manage and submit your budget requests here.</p>
    </div>
  );
}

export default Request;
